import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { Watch } from "react-loader-spinner";
import { toast } from "react-toastify";
import Crop from "../../shared/crop";
import axios from "axios";

const AddNews = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const [isError, setError] = useState(false);
    const [imagePreview, setImagePreview] = useState('');
    const [loading, setLoading] = useState(false);
    const [formValue, setFormValue] = useState({
        id: null,
        title: '',
        image: '',
        description: '',
        image_url: '',
    });

    const onSave = () => {
        if (formValue.title
        ) {
            setError(false);
            setLoading(true);
            const pUrl = id ? API_URL.NEWS_UPDATE : API_URL.NEWS_SAVE;
            axios
                .post(pUrl, formValue)
                .then((res) => {
                    setLoading(false);
                    if (res.data.status === 1) {
                        let message = id
                            ? "News Updated Successfully."
                            : "News Created Successfully.";
                        toast.success(message, { autoClose: 3000, position: "top-right" });
                        setLoading(false);
                        navigate("/settings/news");
                    } else {
                        toast.error(res.data.data)
                    }
                })
                .finally(() => {
                    setLoading(false);
                    setError(true);
                });
        } else {
            setLoading(false);
            setError(true);
        }
    };
    const isRequiredField = (key) => {
        return isError && !formValue[key];
    };

    const onEdit = () => {
        axios.post(API_URL.NEWS_GET, { id: id }).then((res) => {
            if (res.data.status === 1) {
                setFormValue({
                    id: res.data.data.id,
                    title: res.data.data.title,
                    description: res.data.data.description,
                    image: '',
                });
                 setImagePreview(res.data.data.image_url);
            }
        });
    };

    useEffect(() => {
        id && onEdit();
    }, [id]);

    return (
        <>
            <div className="row">
                <div className="col-6">
                    <h1>{id ? "Edit" : "Add"} News</h1>
                </div>
                <div className="col-6">
                    <div className="d-flex align-items-center  justify-content-end">
                        <Link to={"/settings/news"} className="btn btn-secondary">
                            <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
                        </Link>
                    </div>
                </div>
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={(event) => event.preventDefault()}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Title</label>
                                            <input 
                                             className={
                                                    isRequiredField("title")
                                                        ? "form-control required"
                                                        : "form-control"
                                                }
                                                name='title'
                                                type="text"
                                                value={formValue.title}
                                                onChange={(event) => {
                                                    setFormValue({ ...formValue, title: event.target.value })
                                                }}
                                            ></input>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Description</label>
                                            <textarea
                                                type="text"
                                                name="description"
                                                value={formValue.description}
                                                className={
                                                    isRequiredField("description")
                                                        ? "form-control required"
                                                        : "form-control"
                                                }
                                                id="description"
                                                onChange={(event) => {
                                                    setFormValue({ ...formValue, description: event.target.value });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Image</label>
                                            <Crop imagePreview={imagePreview} aspectRatio={'BLOG'} guid={''} cropShape='round'
                                                onChangeCropper={async ({ fileCropped, fileCroppedBase64 }) => {
                                                    setFormValue({ ...formValue, image: fileCroppedBase64 })
                                                    setImagePreview(fileCroppedBase64);
                                                    //   await uploadFile(fileCropped)
                                                }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="form-group text-right">
                                        <button
                                            type="submit"
                                            onClick={onSave}
                                            // disabled={loading}
                                            className="btn btn-primary"
                                        >
                                            {loading ? (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    <Watch color={"white"} height={20} width={20} />
                                                </div>
                                            ) : (
                                                "Save"
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddNews;